import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class PricelistStore extends LocalModel {
    constructor() {
        super('pricelist', {
            namePlural: 'pricelists',
            namePluralReal: 'pricelists',
            sort: 'name',
            limit: 100,
            api: {
                search: {
                    url: '/api/pricelists/',
                    params: {
                        limit: 100,
                        sort: 'name',
                    },
                },
                load: {
                    url: '/api/pricelists/',
                    params: {},
                },
                save: {
                    url: '/api/pricelists/',
                    params: {},
                },
                delete: {
                    url: '/api/pricelists/',
                    params: {},
                },
            },
        });
    }

    @observable newPricelist = {};

    @observable pricelist = {};

    @observable pricelists = [];

    @observable members = [];

    @observable memberSearchResults = [];

    @action
    setMembers = (members) => {
        this.members = members;
    }

    @action
    setMemberSearchResults = (users) => {
        this.memberSearchResults = users;
    }

    createPricelist = async ({ name, customer }) => {
        const response = await util.fetchApi('/api/pricelists/', { method: 'POST' }, { name, customer });
        return response;
    }

    setPrice = async (pricelistId, productId, value) => {
        const response = await util.fetchApi(`/api/pricelists/${pricelistId}`, { method: 'PATCH' }, {
            setPriceProduct: productId,
            setPriceValue: value,
        });
        if (response && response.status === 202 && response.data?.pricelist) {
            this.updateKeyValue('pricelist', response.data.pricelist);
        }
        return response;
    }

    loadMembers = async (pricelistId) => {
        const response = await util.fetchApi(`/api/pricelists/${pricelistId}/members`, { method: 'GET' }, {});
        if (response && response.status === 200) {
            this.setMembers(response.data || []);
        }
        return response;
    }

    addMember = async (pricelistId, userId) => {
        const response = await util.fetchApi(`/api/pricelists/${pricelistId}/members`, { method: 'POST' }, { user: userId });
        if (response && response.status === 202) {
            await this.loadMembers(pricelistId);
        }
        return response;
    }

    removeMember = async (pricelistId, userId) => {
        const response = await util.fetchApi(`/api/pricelists/${pricelistId}/members/${userId}`, { method: 'DELETE' }, {});
        if (response && response.status === 202) {
            await this.loadMembers(pricelistId);
        }
        return response;
    }

    searchMembers = async (search) => {
        const response = await util.fetchApi('/api/pricelists/members/search', { method: 'GET' }, { search });
        if (response && response.status === 200) {
            this.setMemberSearchResults(response.data || []);
        }
        return response;
    }
}

const store = new PricelistStore();
export default store;

export { PricelistStore };
